import type { ReactElement } from 'react';
import { CopyToClipboardButton } from '@/components/shared/CopyToClipboardButton';
import { cn } from '@/lib/utils';

interface AlertSessionIdProps {
  sessionId: string;
  className?: string;
}

/**
 * The alert's agent session ID with a copy button, for the alert window's
 * title row (the expanded table row leaves it to the session timeline).
 */
export function AlertSessionId({
  sessionId,
  className,
}: AlertSessionIdProps): ReactElement {
  return (
    <span
      data-testid="alert-session-id"
      className={cn('flex min-w-0 items-center gap-1.5 text-xs', className)}
    >
      <span className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
        Session
      </span>
      <span className="truncate font-mono" title={sessionId}>
        {sessionId}
      </span>
      <CopyToClipboardButton
        text={sessionId}
        variant="ghost"
        compactCopiedState
        className="h-6 w-6 shrink-0 p-0 text-muted-foreground hover:text-foreground"
      >
        <span className="sr-only">Copy session ID</span>
      </CopyToClipboardButton>
    </span>
  );
}

AlertSessionId.displayName = 'AlertSessionId';
